export default __webpack_public_path__ + "static/media/gr_white.c9745c3c.svg";